import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  Dimensions,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  StatusBar,
  ActivityIndicator,
} from 'react-native';
import Animated, {
  Easing,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import { NavigationContainer } from '@react-navigation/native';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { EventRegister } from 'react-native-event-listeners';
import { ToastProvider } from 'react-native-toast-notifications';
import SplashScreen from 'react-native-splash-screen';
// import RNFS from 'react-native-fs';
import { Helmet } from 'react-helmet';
import { getUniqueId, getUserAgent, isTablet } from 'react-native-device-info';
import _ from 'lodash';
import { menuRef } from './src/navigation/MenuNavigation';
import DayScreen from './src/screens/main/DayScreen';
import DashboardScreen from './src/screens/main/DashboardScreen';
import BrowseScreen from './src/screens/browse/BrowseScreen';
import BrowseBibleScreen from './src/screens/browse/BrowseBibleScreen';
import BibleBookScreen from './src/screens/browse/BibleBookScreen';
import MenuScreen from './src/screens/menu/MenuScreen';
import MenuComponent from './src/components/MenuComponent';
import colors from './src/resources/colors';
import AppContext from './src/navigation/Context';
import { navigationRef } from './src/navigation/RootNavigation';
import json from './src/resources/json';
import images from './src/resources/images';
import DummyScreen from './src/screens/dummy/DummyScreen';
import BookmarksScreen from './src/screens/myServices/BookmarksScreen';
import NotesScreen from './src/screens/myServices/NotesScreen';
import ThisWeeksScreen from './src/screens/browse/ThisWeeksScreen';
import MenuContext from './src/navigation/MenuContext';
import RecentlyViewedScreen from './src/screens/browse/RecentlyViewedScreen';
import SubscriptionsScreen from './src/screens/info/SubscriptionsScreen';
import SettingsScreen from './src/screens/info/SettingsScreen';
import { format } from 'date-fns';
import * as RootNavigation from './src/navigation/RootNavigation';
import DataController from './src/controllers/DataController';
import { useFonts } from 'expo-font';
import LandingScreen from './src/screens/main/LandingScreen';
import AuthenticationController from './src/controllers/AuthenticationController';
import AboutScreen from './src/screens/info/AboutScreen';
import NotesOnLectionaryScreen from './src/screens/info/NotesOnLectionaryScreen';
import DatabaseService from './src/controllers/DatabaseController';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import IAPController from './src/controllers/IAPController';
import * as NavigationBar from 'expo-navigation-bar';
import WelcomeModal from './src/components/WelcomeModal';
import RNBootSplash from 'react-native-bootsplash';

const Stack = createStackNavigator();
const Tab = createBottomTabNavigator();

const headerOptions = {
  title: 'Lectionary',
};

const AppFlow = ({ user }) => {
  return (
    <NavigationContainer ref={navigationRef}>
      <Tab.Navigator
        screenOptions={{
          // header: () => <View />,
          headerShown: false,
          tabBarShowLabel: false,
          tabBarStyle: {
            height: 0,
            borderTopWidth: 0,
            paddingBottom: 0,
            overflow: 'hidden',
          },
        }}>
        <Tab.Screen name="Lectionary" component={Dashboard} />
      </Tab.Navigator>
    </NavigationContainer>
  );
};

const WebFlow = ({ user }) => {
  return (
    <>
      {user ? (
        <NavigationContainer ref={navigationRef}>
          <Tab.Navigator
            screenOptions={{
              // header: () => <View />,
              headerShown: false,
              tabBarShowLabel: false,
              tabBarStyle: {
                height: 0,
                borderTopWidth: 0,
                paddingBottom: 0,
                overflow: 'hidden',
              },
            }}>
            <Tab.Screen name="Lectionary" component={Dashboard} />
          </Tab.Navigator>
        </NavigationContainer>
      ) : <LandingScreen />}
    </>
  );
};

const Dashboard = ({ navigation }) => {
  const context = useContext(AppContext);
  const [route, setRoute] = useState(null);
  const { days } = context;

  useEffect(() => {
    const getAppOpenBehaviour = async () => {
      try {
        const type = await DataController.getAppOpenBehaviour();

        if (type === 0) {
          setRoute('Dashboard')
        } else if (type === 1) {
          setRoute('Day')
        }
      } catch (error) {
        console.log(error);
      }
    };

    getAppOpenBehaviour();
  }, []);

  if (route) {
    const currentDate = new Date();
    const day = days ? days.find((item) => item.Date === DataController.formatDate(currentDate)) : [];
    const dayIndex = days ? days.findIndex((item) => item.Date === DataController.formatDate(currentDate)) : 0;

    return (
      <Stack.Navigator
        initialRouteName={'Dashboard'}
        screenOptions={{
          title: 'Lectionary',
          cardStyle: {
            flex: 1,
          }
        }}>
        <Stack.Screen name="Dashboard" component={DashboardScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen
          name="Day"
          component={DayScreen}
          options={{ title: 'Lectionary' }}
          initialParams={{
            day,
            dayIndex,
          }}
        />
        <Stack.Screen name="Browse" component={BrowseScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Bible" component={BrowseBibleScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Book" component={BibleBookScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Bookmarks" component={BookmarksScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Notes" component={NotesScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="ThisWeeks" component={ThisWeeksScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="RecentlyViewed" component={RecentlyViewedScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Subscriptions" component={SubscriptionsScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="Settings" component={SettingsScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="About" component={AboutScreen} options={{ title: 'Lectionary' }} />
        <Stack.Screen name="NotesOnLectionary" component={NotesOnLectionaryScreen} options={{ title: 'Lectionary' }} />
      </Stack.Navigator>
    );
  } else {
    return (
      <View style={styles.container}>
        <ActivityIndicator color={colors.primary} size="small" />
        <Text style={styles.loading} allowFontScaling={false}>
          {'Loading'}
        </Text>
      </View>
    );
  }
};

const Menu = ({ navigation }) => {
  return (
    <Stack.Navigator screenOptions={{ title: 'Lectionary' }}>
      <Stack.Screen name="Menu" component={MenuScreen} options={{ title: 'Lectionary' }} />
    </Stack.Navigator>
  );
};

const window = Dimensions.get('window');
const screen = Dimensions.get('screen');

const App = () => {
  const [loading, setLoading] = useState(true);
  const [dimensions, setDimensions] = useState({ window, screen });
  const [menuOpen, setMenuOpen] = useState(false);
  const [user, setUser] = useState(null);
  const [UUID, setUUID] = useState(getUniqueId());
  const [trialData, setTrialData] = useState(null);
  const [upgraded, setUpgraded] = useState(false);
  const [IAPLoaded, setIAPLoaded] = useState(false);

  let [fontsLoaded] = useFonts({
    'FiraSans-Regular': require('./assets/fonts/FiraSans-Regular.ttf'),
    'FiraSans-Italic': require('./assets/fonts/FiraSans-Italic.ttf'),
    'FiraSans-Bold': require('./assets/fonts/FiraSans-Bold.ttf'),
    'FiraSans-SemiBold': require('./assets/fonts/FiraSans-SemiBold.ttf'),
    'FiraSans-SemiBoldItalic': require('./assets/fonts/FiraSans-SemiBoldItalic.ttf'),
  });

  const menuWidth = isTablet() || Platform.OS === 'web' ? 375 : Math.floor(Dimensions.get('screen').width * 0.8);
  const menuOffset = useSharedValue(-menuWidth);
  const screenOffset = useSharedValue(0);
  const menuBackgroundOffset = useSharedValue(0);

  const [state, setState] = useState({
    user,
    data: [],
    dimensions,
    activeScreen: 'Home',
    setActiveScreen: (_screen) => setActiveScreen(_screen),
    menuOpen: false,
    trialData,
  });

  const setActiveScreen = (_screen) => {
    setState((_state) => ({ ..._state, activeScreen: _screen }));
  };

  const handleAppStateChange = async (nextAppState) => {
    if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
      if (Platform.OS !== 'web') {
        // await IAPController.checkSubscriptionIsActive();
      }
      changeNavigationBar();
    }
  };

  useEffect(() => {
    changeNavigationBar();
  }, []);

  useEffect(() => {
    const v1Upgrade = async () => {
      const upgraded = await AuthenticationController.checkIfUpgradingFromV1();

      __DEV__ && console.log('upgraded', upgraded);
      setUpgraded(upgraded);
    };

    if (Platform.OS !== 'web') {
      v1Upgrade();
    }
  }, []);

  useEffect(() => {
    const getFreeTrial = async () => {
      let localFreeTrialData = await AuthenticationController.getFreeTrialData();

      if (localFreeTrialData) {
        setTrialData(localFreeTrialData);
        setState((_state) => ({ ..._state, trialData: localFreeTrialData }));
      } else if (UUID) {
        const freeTrialData = await DatabaseService.getFreeTrialData(UUID);

        if (freeTrialData) {
          await AuthenticationController.saveFreeTrialData(freeTrialData);
          setTrialData(freeTrialData);
          setState((_state) => ({ ..._state, trialData: freeTrialData }));
        }
      }
    };

    if (Platform.OS !== 'web') {
      getFreeTrial();
    }
  }, []);

  useEffect(() => {
    const initIAPs = async () => {
      await IAPController.initConnection();
      await IAPController.getSubscriptions();
      await IAPController.checkSubscriptionIsActive();
      setIAPLoaded(true);
    };

    if (Platform.OS !== 'web') {
      initIAPs();
    }

    return async () => {
      if (Platform.OS !== 'web') {
        await IAPController.endConnection();
      }
    };
  }, []);

  useEffect(() => {
    const getUser = async () => {
      const _user = await AuthenticationController.getUser();
      setUser(_user);
      setState((_state) => ({ ..._state, user: _user }));

      if (_user) {
        let subscriptions = await AuthenticationController.getSubscriptions(_user.email, _user.token, _user.requestToken);

        if (subscriptions) {
          subscriptions = subscriptions.filter((item) => item.Status === 1);
          subscriptions = subscriptions.sort((a, b) => new Date(b.ExpiryDate) - new Date(a.ExpiryDate));
          DataController.saveHymnsSubscription(subscriptions);
        }

        await getUserData(_user);
      }
    };

    const loadData = async () => {
      const folder = Object.values(json);
      const lectionary = _.flatten(folder);

      const result = await setData(lectionary);
      __DEV__ && console.log('loadData', result);
      setLoading(false);
    };

    const setData = async (data) => {
      return new Promise(async (resolve, reject) => {
        try {
          updateData('data', data);
          const days = _.sortBy(data.map((item) => ({ id: item[0], ...item[1] })), (item) => item.id);
          // const colors = _.uniq(days.filter((item) => !item.Colour));
          // const daysWithoutColors = days.filter((item) => item.Colour === undefined);
          // const threeCollectDays = days.filter((item) => item.Collect?.length === 3);
          // const oneCollectDays = days.filter((item) => item.Collect?.length === 1);
          // const zeroCollectDays = days.filter((item) => item.Collect?.length === 0 || item.Collect === undefined);

          // console.log(days.length);
          // console.log(threeCollectDays);
          // console.log(oneCollectDays);
          // console.log(zeroCollectDays);
          // console.log('daysWithoutColors', daysWithoutColors);

          // console.log(colors);

          setState({ ...state, days });

          try {
            if (Platform.OS === 'android') {
              RNBootSplash.hide({ fade: true });
            }

            StatusBar.setBarStyle('dark-content');
          } catch (error) {
            console.log(error);
          }

          resolve(true);
        } catch (error) {
          console.log(error);
          reject(false);
        }
      });
    };

    const getUserData = async (_user) => {

      let bookmarks;
      let notes;

      try {
        bookmarks = await DatabaseService.getAllBookmarks(_user.email, _user.requestToken);
      } catch (error) {
        bookmarks = null;
      }

      try {
        notes = await DatabaseService.getAllNotes(_user.email, _user.requestToken);
      } catch (error) {
        notes = null;
      }

      if (bookmarks) {
        await AsyncStorage.setItem('bookmarks', JSON.stringify(bookmarks));
        EventRegister.emit('bookmarks/updated');
      } else {
        bookmarks = await DataController.getBookmarks();

        if (bookmarks.length > 0) {
          for (let i = 0; i < bookmarks.length; i++) {
            await DatabaseService.updateBookmark(_user.email, _user.requestToken, bookmarks[i]);
          }
        }
      }

      if (notes) {
        await AsyncStorage.setItem('notes', JSON.stringify(notes));
        EventRegister.emit('notes/updated');
      } else {
        notes = await DataController.getAllNotes();

        if (notes.length > 0) {
          for (let i = 0; i < notes.length; i++) {
            let _note = { id: notes[i].id, note: encodeURI(notes[i].note) };
            await DatabaseService.updateNote(_user.email, _user.requestToken, _note);
          }
        }
      }
    };

    const updateData = (key, value) => {
      // updateValue(key, value);
      setState({ ...state, data: value });
    };

    getUser();
    loadData();
  }, []);

  useEffect(() => {

    EventRegister.addEventListener('menu/close-menu', (noWait) => {
      // EventRegister.emit('menu/menu-closed');
      setTimeout(() => {
        // Function call will initiate animation and update the menuOpen state value
        menuButtonPressed(false);
      }, noWait ? 0 : 300);
    });

    return () => {
      EventRegister.removeEventListener('menu/close-menu');
    };
  }, []);

  // This will only be called when menuButtonPress is called
  useEffect(() => {
    const toggleMenu = (value) => {
      menuButtonPressed(value ? false : !menuOpen);
    };

    EventRegister.addEventListener('menu/toggle-menu', (value) => {
      toggleMenu(value);
    });

    return () => {
      EventRegister.removeEventListener('menu/toggle-menu');
    };
  }, [menuButtonPressed]);

  const changeNavigationBar = async () => {
    if (Platform.OS === 'android') {
      await NavigationBar.setBackgroundColorAsync(colors.accentWhite);
    }
  };

  /* This function handles the animation of the menu opening/closing. It'll also set the menuOpen state value
     to the 'value' parameter passed in (true or false) */
  const menuButtonPressed = useCallback((value) => {
    // Set animations depending on whether opening or closing the menu
    menuBackgroundOffset.value = withTiming(value ? 1 : 0, {
      duration: 100,
      easing: Easing.inOut(Easing.exp),
    });

    menuOffset.value = withTiming(value ? 0 : -menuWidth, {
      duration: 150,
      easing: Easing.inOut(Easing.exp),
    });

    // Set menuOpen value depending on what was passed in
    setMenuOpen(value);

    setState((_state) => ({ ..._state, menuOpen: value }));

    if (!value) {
      setTimeout(() => {
        try {
          if (menuRef.current.canGoBack()) {
            menuRef.current.goBack();
          }
        } catch (error) {
          console.log(error);
        }
      }, 250);
    }
  }, [menuOffset, menuWidth, screenOffset, menuBackgroundOffset]
  )

  useEffect(() => {
    const listener = Dimensions.addEventListener('change', dimensionChange);

    return () => {
      try {
        listener.remove();
      } catch (error) {
        console.log(error);
      }
    };
  }, [dimensionChange, state]);

  useEffect(() => {
    EventRegister.addEventListener('auth/user-changed', (value) => {
      setUser(value);
      setState((_state) => ({ ..._state, user: value }));
    });

    return () => {
      EventRegister.removeEventListener('auth/user-changed');
      EventRegister.removeEventListener('auth/logout');
    };
  }, []);

  const dimensionChange = useCallback(
    ({ window, screen }) => {
      setDimensions({ window, screen });
      setState({ ...state, dimensions: { window, screen } });
    },
    [state],
  );

  const updateValue = useCallback(
    (key, value) => {
      setState({ ...state, [key]: value });
    },
    [state],
  );

  if (loading && !fontsLoaded) {
    return (
      <View style={styles.container}>
        <ActivityIndicator color={colors.primary} size="small" />
        <Text style={styles.loading} allowFontScaling={false}>
          {'Loading'}
        </Text>
      </View>
    );
  }

  return (
    <>
      {Platform.OS === 'web' && (
        <Helmet>
          <link id="favicon" rel="icon" href={images.appIcon} type="image/x-icon" />
          <link rel="shortcut icon" href={images.appIcon} />
        </Helmet>
      )}
      <GestureHandlerRootView style={{ flex: 1 }}>
        <AppContext.Provider value={state}>
          <MenuContext.Provider value={menuOpen}>
            <StatusBar backgroundColor={colors.grey20} style="dark" />
            <ToastProvider style={{ zIndex: 9999999 }} offsetBottom={100}>
              {Platform.OS === 'web' ? (
                <WebFlow user={user} />
              ) : (
                <>
                  <WelcomeModal
                    loaded={IAPLoaded}
                    trialData={trialData}
                    upgraded={upgraded}
                  />
                  <AppFlow user={user} />
                </>
              )}
              <MenuComponent
                menuOffset={menuOffset}
                menuBackgroundOffset={menuBackgroundOffset}
                menuOpen={menuOpen}
                menuButtonPressed={menuButtonPressed}>
                <Menu />
              </MenuComponent>
            </ToastProvider>
          </MenuContext.Provider>
        </AppContext.Provider>
      </GestureHandlerRootView>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.accentWhite,
    alignItems: 'center',
    justifyContent: 'center',
  },
  loading: {
    fontFamily: 'FiraSans-SemiBold',
    fontSize: 24,
    fontWeight: Platform.OS === 'ios' ? '600' : 'normal',
    fontStyle: 'normal',
    lineHeight: 30,
    letterSpacing: -0.1,
    textAlign: 'center',
    color: colors.primary,
    marginTop: 10,
  },
  menuBackgroundContainer: {
    flex: 1,
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  menuBackgroundButton: {
    flex: 1,
    backgroundColor: 'rgba(39,41,44,0.3)',
  },
  menu: {
    flex: 1,
    overflow: 'hidden',
    position: 'absolute',
    top: 0,
    bottom: 0,
    width: isTablet() || Platform.OS === 'web' ? 375 : '80%',
    shadowColor: 'rgba(0, 0, 0, 0.1)',
    shadowOffset: {
      width: 3,
      height: 0,
    },
    shadowRadius: 0,
    shadowOpacity: 1,
    elevation: 3,
    backgroundColor: colors.accentBlack,
  },
});

export default App;
